import { useMutation } from '@tanstack/react-query';
import useCart from 'components/Cart/Cart.hooks';
import {
  ApplyPromoCodePayload,
  RemoveAllPromosPayload,
  applyPromoCode,
  removeAllPromos,
} from 'utils/api/cartApis';

export default function usePromoCodeActions() {
  const { refetchOrder } = useCart();

  const applyPromoMutation = useMutation(
    async (payload: ApplyPromoCodePayload) => {
      const response = await applyPromoCode(payload);

      // This make sure the cart is updated after applying the promo code
      await refetchOrder?.();

      return response;
    },
  );
  const removeAllPromosMutation = useMutation(
    async (payload: RemoveAllPromosPayload) => {
      const response = await removeAllPromos(payload);

      // This make sure the cart is updated after removing the promo code
      await refetchOrder?.();

      return response;
    },
  );

  return {
    applyPromoMutation,
    removeAllPromosMutation,
  };
}
